import { render } from "./add-to-cart.vue?vue&type=template&id=3ff0d7dc"
import script from "./add-to-cart.vue?vue&type=script&lang=js"
export * from "./add-to-cart.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__